// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-UpgradeTurbo__Dashboard .Polaris-Banner {
  background-color: #fffbf3;
  padding: 0;
}

.BC-UpgradeTurbo__Dashboard.BC-UpgradeTurbo__Dashboard--turbo .Polaris-Banner {
  background-color: #ebf9fc;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .Polaris-Banner__Ribbon {
  display: none;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info {
  position: relative;
  padding: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info.turbo-banner .actions {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-top: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner:has(.turbo-banner--orange) {
  background-color: #fffbf3;
}

.BC-UpgradeTurbo__Dashboard
  .Polaris-Banner
  .banner-info.turbo-banner
  .actions
  .Polaris-Button--plain
  span {
  text-decoration: underline;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info.turbo-banner .actions .Polaris-Icon {
  width: 1rem;
  height: 1rem;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .title--smaller {
  font-size: 16px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .turbo-img {
  position: absolute;
  right: 0;
  top: 0;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .turbo-img.turbo-img--si {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  bottom: 0;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-list {
  margin: 8px 0;
  padding-left: 24px;
  margin-bottom: 24px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-list li {
  line-height: 22px;
}

.BC-UpgradeTurbo__Dashboard
  .Polaris-Banner
  .banner-info-cta
  .Polaris-ButtonGroup__Item:first-child
  .Polaris-Button {
  background-color: #ffc96b;
  box-shadow: 0px -1px 0px 0px #00000033 inset, 0px 1px 0px 0px #00000014;
}

.BC-UpgradeTurbo__Dashboard
  .Polaris-Banner
  .banner-info-cta
  .Polaris-ButtonGroup__Item:first-child
  .Polaris-Button:hover {
  background-color: #f3be63;
}

.BC-UpgradeTurbo__Dashboard
  .Polaris-Banner
  .banner-info
  .banner-info-cta.banner-info-cta--collapsed {
  margin-top: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline {
  padding-left: 4px;
}

.BC-UpgradeTurbo__Dashboard
  .Polaris-Banner
  .banner-info
  .banner-info-cta.banner-info-cta--outline
  .Polaris-ButtonGroup__Item:last-child {
  margin-left: 20px;
}

.BC-UpgradeTurbo__Dashboard
  .Polaris-Banner
  .banner-info
  .banner-info-cta.banner-info-cta--outline
  .Polaris-ButtonGroup__Item:first-child
  .Polaris-Button {
  background-color: transparent;
  box-shadow: 0px 1px 0px 0px #0000000d;
  border-color: #98c6cd;
}

.BC-UpgradeTurbo__Dashboard
  .Polaris-Banner
  .banner-info
  .banner-info-cta.banner-info-cta--outline
  .Polaris-ButtonGroup__Item:first-child
  .Polaris-Button:hover {
  background-color: #e3f2f5;
}

.BC-UpgradeTurbo__Dashboard
  .Polaris-Banner
  .banner-info
  .banner-info-cta.banner-info-cta--outline
  .Polaris-ButtonGroup__Item:last-child
  .Polaris-Button__Text {
  display: flex;
  align-items: center;
  gap: 2px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action {
  position: absolute;
  top: 20px;
  right: 24px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  width: 50px;
}

.BC-UpgradeTurbo__Dashboard.BC-UpgradeTurbo__Dashboard--turbo
  .Polaris-Banner
  .banner-info
  .banner-action {
  width: 20px;
  height: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action > div:first-child {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action .Polaris-Button {
  padding: 0;
  width: 20px;
  min-width: unset;
  min-height: unset;
  display: block;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action .Polaris-Icon__Svg {
  fill: #5c5f62;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra {
  position: absolute;
  bottom: 27px;
  right: 20px;
  z-index: 10;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra p {
  display: flex;
  align-items: center;
  color: rgb(109, 113, 117);
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Link {
  display: flex;
  align-items: center;
  margin: 0 4px;
  margin-left: 6px;
  color: rgb(0, 91, 211);
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Icon {
  margin: 0;
  margin-left: 4px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Icon__Svg {
  fill: rgb(0, 91, 211);
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage {
  margin-bottom: 16px;
  padding-left: 4px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p,
.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p span {
  font-weight: 500;
  position: relative;
  top: 1px;
}

.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage .Polaris-Icon__Svg {
  fill: #5c5f62;
}

.BC-Page__Theme-Setup .BC-UpgradeTurbo__Dashboard,
.BC-Page__ShopifyIntegration .BC-UpgradeTurbo__Dashboard {
  margin-bottom: 24px;
}

.BC-UpgradeTurbo__Campaign {
  position: relative;
  margin-bottom: 24px;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner--statusInfo {
  background: #ebf9fc;
  border-color: #98c6cd;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 16px;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link {
  display: inline-flex;
  align-items: center;
  color: #2c6ecb !important;
  gap: 2px;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link .Polaris-Icon__Svg {
  fill: #2c6ecb;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action .Polaris-Button {
  padding: 0;
  width: 20px;
  height: 20px;
  min-width: auto;
  min-height: auto;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action .Polaris-Icon__Svg {
  fill: #5c5f62;
}

.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .guide-list {
  margin-top: 0;
  padding-left: 16px;
}

.BC-GuideBanner {
  box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000d;
  border-radius: 8px;
  padding: 10px;
  position: relative;
  background-color: #fff;
  margin-top: 40px !important;
}

.BC-GuideBanner .close {
  position: absolute;
  top: 16px;
  right: 14px;
  cursor: pointer;
}

.BC-GuideBanner .BC-GuideBanner__Content {
  display: flex;
  gap: 16px;
}

.BC-GuideBanner .BC-GuideBanner__Content > div:nth-child(2) {
  margin-right: 38px;
}

.BC-GuideBanner .BC-GuideBanner__Content__Video {
  position: relative;
  cursor: pointer;
  max-height: 90px;
}

.BC-GuideBanner .BC-GuideBanner__Content__Video .btn-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.BC-GuideBanner .BC-GuideBanner__Content__Video .btn-play img {
  width: 40px;
  height: 40px;
}

.BC-GuideBanner .BC-GuideBanner__Content .BC-GuideBanner__Content__Thumbnail {
  border-radius: 4px;
  max-width: 160px;
  max-height: 90px;
  cursor: pointer;
}

.BC-GuideBanner .BC-GuideBanner__Content__Title {
  font-weight: 600;
  margin-bottom: 4px;
}

.BC-GuideBanner .BC-GuideBanner__Actions {
  display: flex;
  margin-top: 10px;
  gap: 8px;
}

.BC-GuideBanner .BC-GuideBanner__Actions .Polaris-Button {
  border-radius: 4px;
  border: 1px solid #babfc3;
  min-height: auto;
  padding: 3px 12px;
}

.BC-GuideBanner .BC-GuideBanner__Actions .Polaris-Button .Polaris-Button__Text {
  font-weight: 500;
  font-size: 12px;
}

.BC-Page__StandardSearch .BC-Page__SearchSettings .BC-GuideBanner {
  margin-top: 16px !important;
}

.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .BC-GuideBanner,
.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .BC-GuideBanner,
.BC-Page__StandardSearch .BC-Page__InCollectionSettings .BC-GuideBanner,
.BC-Page__StandardSearch .BC-Page__Synonym .BC-GuideBanner,
.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .BC-GuideBanner,
.BC-Page__StandardSearch .BC-Page__Redirect .BC-GuideBanner,
.BC-Page__StandardSearch .BC-Page__StopWords .BC-GuideBanner,
.BC-Page__AdvancedSearch .BC-Page__AdvancedSearch_General .BC-GuideBanner,
.BC-Page__AdvancedSearch .BC-Page__Semantic .BC-GuideBanner,
.BC-Page__AdvancedSearch .BC-Page__ProductPerformanceRanking .BC-GuideBanner,
.BC-Page__AdvancedSearch .BC-Page__SearchPersonalization .BC-GuideBanner,
.BC-Page__PostPurchase .BC-GuideBanner {
  margin-top: 16px !important;
}

.BC-Page__TestYourSearch .BC-GuideBanner {
  width: 77%;
  margin: auto;
}

.BC-Page__BackInStock-Subscription .BC-GuideBanner {
  margin-top: 40px !important;
}

.BC-Page__ShopifyIntegration .BC-GuideBanner,
.BC-Page__Integration .BC-GuideBanner,
.BC-Page__Personalization .BC-GuideBanner {
  margin-top: 16px !important;
  margin-bottom: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/banner.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;EAKE,yBAAyB;EACzB,uEAAuE;AACzE;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;;;EAME,6BAA6B;EAC7B,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gEAAgE;EAChE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;;EAYE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,2BAA2B;EAC3B,mBAAmB;AACrB","sourcesContent":[".BC-UpgradeTurbo__Dashboard .Polaris-Banner {\n  background-color: #fffbf3;\n  padding: 0;\n}\n\n.BC-UpgradeTurbo__Dashboard.BC-UpgradeTurbo__Dashboard--turbo .Polaris-Banner {\n  background-color: #ebf9fc;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .Polaris-Banner__Ribbon {\n  display: none;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info {\n  position: relative;\n  padding: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info.turbo-banner .actions {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner:has(.turbo-banner--orange) {\n  background-color: #fffbf3;\n}\n\n.BC-UpgradeTurbo__Dashboard\n  .Polaris-Banner\n  .banner-info.turbo-banner\n  .actions\n  .Polaris-Button--plain\n  span {\n  text-decoration: underline;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info.turbo-banner .actions .Polaris-Icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .title--smaller {\n  font-size: 16px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .turbo-img {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .turbo-img.turbo-img--si {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  bottom: 0;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-list {\n  margin: 8px 0;\n  padding-left: 24px;\n  margin-bottom: 24px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info-list li {\n  line-height: 22px;\n}\n\n.BC-UpgradeTurbo__Dashboard\n  .Polaris-Banner\n  .banner-info-cta\n  .Polaris-ButtonGroup__Item:first-child\n  .Polaris-Button {\n  background-color: #ffc96b;\n  box-shadow: 0px -1px 0px 0px #00000033 inset, 0px 1px 0px 0px #00000014;\n}\n\n.BC-UpgradeTurbo__Dashboard\n  .Polaris-Banner\n  .banner-info-cta\n  .Polaris-ButtonGroup__Item:first-child\n  .Polaris-Button:hover {\n  background-color: #f3be63;\n}\n\n.BC-UpgradeTurbo__Dashboard\n  .Polaris-Banner\n  .banner-info\n  .banner-info-cta.banner-info-cta--collapsed {\n  margin-top: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-cta.banner-info-cta--outline {\n  padding-left: 4px;\n}\n\n.BC-UpgradeTurbo__Dashboard\n  .Polaris-Banner\n  .banner-info\n  .banner-info-cta.banner-info-cta--outline\n  .Polaris-ButtonGroup__Item:last-child {\n  margin-left: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard\n  .Polaris-Banner\n  .banner-info\n  .banner-info-cta.banner-info-cta--outline\n  .Polaris-ButtonGroup__Item:first-child\n  .Polaris-Button {\n  background-color: transparent;\n  box-shadow: 0px 1px 0px 0px #0000000d;\n  border-color: #98c6cd;\n}\n\n.BC-UpgradeTurbo__Dashboard\n  .Polaris-Banner\n  .banner-info\n  .banner-info-cta.banner-info-cta--outline\n  .Polaris-ButtonGroup__Item:first-child\n  .Polaris-Button:hover {\n  background-color: #e3f2f5;\n}\n\n.BC-UpgradeTurbo__Dashboard\n  .Polaris-Banner\n  .banner-info\n  .banner-info-cta.banner-info-cta--outline\n  .Polaris-ButtonGroup__Item:last-child\n  .Polaris-Button__Text {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action {\n  position: absolute;\n  top: 20px;\n  right: 24px;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 20px;\n  width: 50px;\n}\n\n.BC-UpgradeTurbo__Dashboard.BC-UpgradeTurbo__Dashboard--turbo\n  .Polaris-Banner\n  .banner-info\n  .banner-action {\n  width: 20px;\n  height: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action > div:first-child {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action .Polaris-Button {\n  padding: 0;\n  width: 20px;\n  min-width: unset;\n  min-height: unset;\n  display: block;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-action .Polaris-Icon__Svg {\n  fill: #5c5f62;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra {\n  position: absolute;\n  bottom: 27px;\n  right: 20px;\n  z-index: 10;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra p {\n  display: flex;\n  align-items: center;\n  color: rgb(109, 113, 117);\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Link {\n  display: flex;\n  align-items: center;\n  margin: 0 4px;\n  margin-left: 6px;\n  color: rgb(0, 91, 211);\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Icon {\n  margin: 0;\n  margin-left: 4px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-extra .Polaris-Icon__Svg {\n  fill: rgb(0, 91, 211);\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage {\n  margin-bottom: 16px;\n  padding-left: 4px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p,\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage p span {\n  font-weight: 500;\n  position: relative;\n  top: 1px;\n}\n\n.BC-UpgradeTurbo__Dashboard .Polaris-Banner .banner-info .banner-info-manage .Polaris-Icon__Svg {\n  fill: #5c5f62;\n}\n\n.BC-Page__Theme-Setup .BC-UpgradeTurbo__Dashboard,\n.BC-Page__ShopifyIntegration .BC-UpgradeTurbo__Dashboard {\n  margin-bottom: 24px;\n}\n\n.BC-UpgradeTurbo__Campaign {\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner--statusInfo {\n  background: #ebf9fc;\n  border-color: #98c6cd;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  color: #2c6ecb !important;\n  gap: 2px;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .Polaris-Link .Polaris-Icon__Svg {\n  fill: #2c6ecb;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 20px;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action .Polaris-Button {\n  padding: 0;\n  width: 20px;\n  height: 20px;\n  min-width: auto;\n  min-height: auto;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .banner-action .Polaris-Icon__Svg {\n  fill: #5c5f62;\n}\n\n.BC-UpgradeTurbo__Campaign .Polaris-Banner .banner-info .guide-list {\n  margin-top: 0;\n  padding-left: 16px;\n}\n\n.BC-GuideBanner {\n  box-shadow: 0px 0px 1px 0px #00000040, 0px 2px 1px 0px #0000000d;\n  border-radius: 8px;\n  padding: 10px;\n  position: relative;\n  background-color: #fff;\n  margin-top: 40px !important;\n}\n\n.BC-GuideBanner .close {\n  position: absolute;\n  top: 16px;\n  right: 14px;\n  cursor: pointer;\n}\n\n.BC-GuideBanner .BC-GuideBanner__Content {\n  display: flex;\n  gap: 16px;\n}\n\n.BC-GuideBanner .BC-GuideBanner__Content > div:nth-child(2) {\n  margin-right: 38px;\n}\n\n.BC-GuideBanner .BC-GuideBanner__Content__Video {\n  position: relative;\n  cursor: pointer;\n  max-height: 90px;\n}\n\n.BC-GuideBanner .BC-GuideBanner__Content__Video .btn-play {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.BC-GuideBanner .BC-GuideBanner__Content__Video .btn-play img {\n  width: 40px;\n  height: 40px;\n}\n\n.BC-GuideBanner .BC-GuideBanner__Content .BC-GuideBanner__Content__Thumbnail {\n  border-radius: 4px;\n  max-width: 160px;\n  max-height: 90px;\n  cursor: pointer;\n}\n\n.BC-GuideBanner .BC-GuideBanner__Content__Title {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.BC-GuideBanner .BC-GuideBanner__Actions {\n  display: flex;\n  margin-top: 10px;\n  gap: 8px;\n}\n\n.BC-GuideBanner .BC-GuideBanner__Actions .Polaris-Button {\n  border-radius: 4px;\n  border: 1px solid #babfc3;\n  min-height: auto;\n  padding: 3px 12px;\n}\n\n.BC-GuideBanner .BC-GuideBanner__Actions .Polaris-Button .Polaris-Button__Text {\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.BC-Page__StandardSearch .BC-Page__SearchSettings .BC-GuideBanner {\n  margin-top: 16px !important;\n}\n\n.BC-Page__StandardSearch .BC-Page__InstantSearchDisplay .BC-GuideBanner,\n.BC-Page__StandardSearch .BC-Page__SearchPageDisplay .BC-GuideBanner,\n.BC-Page__StandardSearch .BC-Page__InCollectionSettings .BC-GuideBanner,\n.BC-Page__StandardSearch .BC-Page__Synonym .BC-GuideBanner,\n.BC-Page__StandardSearch .BC-Page__SuggestionDictionary .BC-GuideBanner,\n.BC-Page__StandardSearch .BC-Page__Redirect .BC-GuideBanner,\n.BC-Page__StandardSearch .BC-Page__StopWords .BC-GuideBanner,\n.BC-Page__AdvancedSearch .BC-Page__AdvancedSearch_General .BC-GuideBanner,\n.BC-Page__AdvancedSearch .BC-Page__Semantic .BC-GuideBanner,\n.BC-Page__AdvancedSearch .BC-Page__ProductPerformanceRanking .BC-GuideBanner,\n.BC-Page__AdvancedSearch .BC-Page__SearchPersonalization .BC-GuideBanner,\n.BC-Page__PostPurchase .BC-GuideBanner {\n  margin-top: 16px !important;\n}\n\n.BC-Page__TestYourSearch .BC-GuideBanner {\n  width: 77%;\n  margin: auto;\n}\n\n.BC-Page__BackInStock-Subscription .BC-GuideBanner {\n  margin-top: 40px !important;\n}\n\n.BC-Page__ShopifyIntegration .BC-GuideBanner,\n.BC-Page__Integration .BC-GuideBanner,\n.BC-Page__Personalization .BC-GuideBanner {\n  margin-top: 16px !important;\n  margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
